import { AdvisorsLayout, DirectorySection } from '@src/components/sco/Advisors'
import { advisorsDirectorySeo } from '@src/components/sco/Advisors/utils/advisorsSeo'
import { usePageSEO } from '@src/hooks/usePageSEO'
import { useRouter } from 'next/router'

export { getServerSideProps } from '@src/lib/server-side-rendering'

/** Guest-reachable and server-rendered (L3). `?category=` canonicals to `/advisors/directory/{key}`. */
export default function Page() {
  const router = useRouter()
  const category = typeof router.query.category === 'string' ? router.query.category : null
  usePageSEO(advisorsDirectorySeo(category))

  return (
    <AdvisorsLayout>
      <DirectorySection />
    </AdvisorsLayout>
  )
}
